<cui-restricted-layout [freeContentStyle]="false"></cui-restricted-layout>
